import React from "react";
import { View, Text, Image } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";

const RewardWagerSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;
  return (
    <View
      style={{
        flexDirection: "column",
        margin: isMobile ? 0 : 20,
        width: isMobile ? "100%" : 385,
      }}
    >
      <View
        style={{
          alignItems:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "flex-start"
              : "center",
        }}
      >
        <View style={{ marginBottom: 5 }}>
          <View
            style={{
              maxWidth:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "100%"
                  : 256,
              alignContent: "center",
            }}
          >
            <Skeletons
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 12
                  : 16
              }
              width={"200px"}
              style={{ borderRadius: 6 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
            <Skeletons
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 16
                  : 24
              }
              width={"150px"}
              style={{ borderRadius: 6, marginTop: 4 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          </View>
        </View>
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 212 : "auto",
            marginTop: 10,
            justifyContent: "center",
          }}
        >
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 28
                : 34
            }
            width={"80px"}
            style={{ borderRadius: 10, alignSelf: "center" }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>
      </View>
      <View>
        <Skeletons
          height={18}
          width={"80px"}
          style={{ borderRadius: 6, marginVertical: 10 }}
          backgroundColor={AppColors.gray_C4C4C4}
        />
        <View
          style={{
            flexDirection: "row",
            alignItems: "flex-start",
            flexWrap: isMobile ? "wrap" : "nowrap",
          }}
        >
          {[...Array(isMobile ? 4 : 5)].map((_, index) => (
            <View key={index} style={{ alignItems: "center", marginRight: 10 }}>
              <Skeletons
                height={50}
                width={"50px"}
                style={{ borderRadius: 10 }}
                backgroundColor={AppColors.gray_C4C4C4}
              />
              <Skeletons
                height={20}
                width={"40px"}
                style={{ borderRadius: 6, marginTop: 4 }}
                backgroundColor={AppColors.gray_C4C4C4}
              />
              <Skeletons
                height={12}
                width={"60px"}
                style={{ borderRadius: 6, marginTop: 4 }}
                backgroundColor={AppColors.gray_C4C4C4}
              />
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default RewardWagerSkeleton;
